/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { hideLoaderAction, showLoaderAction } from "./loaderActionCreator";

export const showLoader = (dispatch) => {
  dispatch(showLoaderAction());
}

export const hideLoader = (dispatch) => {
  dispatch(hideLoaderAction());
}
